import styled from 'styled-components/macro'
import { GLOBALS } from '.'

export const Line = styled.hr`
  border: none;
  margin: 0;
  width: 100%;
  border-top: 1px solid ${GLOBALS.colors.grey[400]};
`
